export function tryGetValueFromJson(value: string | undefined, field: string): string | undefined {
  if (value) {
    try {
      const result = JSON.parse(value) as Record<string, string>;
      return result[field];
    } catch {
      return value;
    }
  }
  return value;
}
